<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="border-t bg-background">
    <div class="container mx-auto px-4 py-6">
      <div class="flex flex-col items-center justify-between gap-4 md:flex-row">
        <p class="text-sm text-muted-foreground">
          © {{ currentYear }} RETAINTIVE.AI. All rights reserved.
        </p>
        <nav class="flex gap-6">
          <a
            href="https://retaintive.ai/terms"
            target="_blank"
            rel="noopener noreferrer"
            class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Terms of Service
          </a>
          <a
            href="https://retaintive.ai/privacy"
            target="_blank"
            rel="noopener noreferrer"
            class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Privacy Policy
          </a>
        </nav>
      </div>
    </div>
  </footer>
</template>
